/**
 * Read current user id from the same localStorage keys the auth layer uses (`AuthContext` → `cyberrange_auth_user`),
 * with a legacy fallback for `user`.
 */
export function getStoredUserIdFromLocalStorage(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  for (const key of ['cyberrange_auth_user', 'user'] as const) {
    const raw = window.localStorage.getItem(key);
    if (!raw) continue;
    try {
      const p = JSON.parse(raw) as { id?: number | string; user_id?: string };
      const id = p.id ?? p.user_id;
      if (id != null && id !== '') return String(id);
    } catch {
      continue;
    }
  }
  return undefined;
}
